import { render, staticRenderFns } from "./PieApiPlayer.vue?vue&type=template&id=1520459d"
import script from "./PieApiPlayer.vue?vue&type=script&lang=ts"
export * from "./PieApiPlayer.vue?vue&type=script&lang=ts"
import style0 from "./PieApiPlayer.vue?vue&type=style&index=0&id=1520459d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports